"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _data = require("@ux/data");
var _text = _interopRequireDefault(require("@ux/text"));
var _alert = _interopRequireDefault(require("@ux/alert"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ContactSupportMessage = ({
  phoneNumber = '',
  messageId = 'contact-support-message',
  inAlert,
  alertEmphasis = 'critical',
  ...props
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const [supportPhoneNumber, setSupportPhone] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    const {
      supportContacts: {
        technicalSupportPhone = ''
      } = {}
    } = _data.data || {};
    if (phoneNumber?.length > 0) {
      setSupportPhone(phoneNumber);
    } else {
      setSupportPhone(technicalSupportPhone);
    }
  }, []);
  const supportMessage = /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: formatMessage({
      id: messageId
    }, {
      supportPhone: supportPhoneNumber,
      custom: msg => msg
    })
  });
  if (inAlert) {
    return /*#__PURE__*/_react.default.createElement(_alert.default, (0, _extends2.default)({
      emphasis: alertEmphasis
    }, props), supportMessage);
  }
  return supportMessage;
};
ContactSupportMessage.propTypes = {
  phoneNumber: _propTypes.default.string,
  messageId: _propTypes.default.string,
  inAlert: _propTypes.default.bool,
  alertId: _propTypes.default.string,
  customLink: _propTypes.default.func
};
var _default = exports.default = ContactSupportMessage;